import jMoment from "jalali-moment";

type props = {
  date: string | undefined;
  format?: string;
};

function convertGregorianToJalali({ date, format = "jYYYY/jMM/jDD" }: props) {
  console.log(date);
  return jMoment(date).format(format);
}

export default convertGregorianToJalali;
